import {  RenderItemFormSidebarPanelCtx } from "datocms-plugin-sdk";
import React from "react";
import { DocxExporter } from "../components/DocxExporter";
import { Canvas } from "datocms-react-ui";



type Props = {
  ctx: RenderItemFormSidebarPanelCtx,
};

function ArticleToDocxSidePanel({ ctx }: Props) {
  const locale = ctx.locale as string;
  
  const title = (ctx.formValues as any).title[locale] as string;
  const headline = (ctx.formValues as any).headline[locale] as string;
  const paragraph1 = (ctx.formValues as any).paragraph1[locale] as any[];
  const paragraph2 = (ctx.formValues as any).paragraph2[locale] as any[];
  const paragraph3 = (ctx.formValues as any).paragraph3[locale] as any[];
  const paragraph4 = (ctx.formValues as any).paragraph4[locale] as any[];

  const body = [
    {
      type: "paragraph",
      children: [{ text: headline}],
    },
    "image1.png",
    ...paragraph1,
    "image2.png",
    ...paragraph2,
    "image3.png",
    ...paragraph3,        
    "image4.png",
    ...paragraph4,
  ];

  return <Canvas ctx={ctx}>
    <DocxExporter
      title={title}
      body = {body}
    />
  </Canvas>;
};

export default ArticleToDocxSidePanel;

